class ProductTabs {
    constructor(tabsContainer) {
        this.tabsContainer = tabsContainer;
        this.tabButtons = tabsContainer.querySelectorAll(".product-tabs__button");
        this.tabPanels = tabsContainer.querySelectorAll(".product-tabs__panel");

        this.init();
    }

    init() {
        this.setupEventListeners();
    }

    setupEventListeners() {
        this.tabButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();
                const targetTab = button.dataset.tab;
                this.switchTab(targetTab);
            });
        });
    }

    switchTab(targetTab) {
        this.tabButtons.forEach((button) => {
            button.classList.remove("product-tabs__button--active");
            if (button.dataset.tab === targetTab) {
                button.classList.add("product-tabs__button--active");
            }
        });

        this.tabPanels.forEach((panel) => {
            panel.classList.remove("product-tabs__panel--active");
            if (panel.dataset.panel === targetTab) {
                panel.classList.add("product-tabs__panel--active");
            }
        });
    }
}

class ProductPageForm {
    constructor() {
        this.form = document.getElementById('productForm');
        this.addToCartBtn = document.querySelector('[data-add-to-cart]');
        this.variantOptions = document.querySelectorAll('.variant-option-input');
        this.isInitialLoad = true;

        if (!this.form) return;

        this.init();
    }

    init() {
        this.setupEventListeners();
        this.updateVariantId();
        this.isInitialLoad = false;
    }

    setupEventListeners() {
        this.variantOptions.forEach(input => {
            input.addEventListener('change', () => {
                this.updateVariantId();
                this.updateButtonStates();
            });
        });

        if (this.addToCartBtn) {
            this.addToCartBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleAddToCart();
            });
        }

        const quantityBtns = document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]');
        const quantityInput = document.querySelector('[data-quantity-input]');

        quantityBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const isPlus = btn.hasAttribute('data-quantity-plus');
                this.updateQuantity(isPlus);
            });
        });

        if (quantityInput) {
            quantityInput.addEventListener('change', () => {
                this.validateQuantity();
            });
        }
    }

    updateVariantId() {
        const selectedOptions = this.getSelectedOptions();
        const matchingVariant = this.findVariantByOptions(selectedOptions);

        if (matchingVariant) {
            const variantIdInput = this.form.querySelector('input[name="id"]');
            if (variantIdInput) {
                variantIdInput.value = matchingVariant.id;
            }

            this.updatePrice(matchingVariant);
            this.updateAvailability(matchingVariant);
            this.updateStockQuantity(matchingVariant);
            this.updateVariantLabel(matchingVariant);

            if (window.productGallery && !this.isInitialLoad) {
                window.productGallery.updateGalleryForVariant(matchingVariant.id);
            }
        }
    }

    getSelectedOptions() {
        const options = [];
        const optionInputs = {};

        this.variantOptions.forEach(input => {
            if (input.checked) {
                const optionName = input.getAttribute('data-option-name');
                const optionValue = input.getAttribute('data-option-value');
                optionInputs[optionName] = optionValue;
            }
        });

        if (window.productOptions) {
            window.productOptions.forEach(optionName => {
                if (optionInputs[optionName]) {
                    options.push(optionInputs[optionName]);
                }
            });
        }

        return options;
    }

    findVariantByOptions(selectedOptions) {
        if (!window.productVariants || selectedOptions.length === 0) return null;

        return window.productVariants.find(variant => {
            return selectedOptions.every((option, index) =>
                variant.options[index] === option
            );
        });
    }

    updateButtonStates() {
        const selectedOptions = this.getSelectedOptions();
        const matchingVariant = this.findVariantByOptions(selectedOptions);
        const isAvailable = matchingVariant && matchingVariant.available && (!matchingVariant.inventory_management || matchingVariant.inventory_quantity > 0);

        if (this.addToCartBtn) {
            const btnText = this.addToCartBtn.querySelector('.btn__text');

            this.addToCartBtn.disabled = !isAvailable;

            if (btnText) {
                btnText.textContent = isAvailable ? 'Ajouter au panier' : 'Indisponible';
            }
        }
    }

    updatePrice(variant) {
        const priceElements = document.querySelectorAll('.price');
        priceElements.forEach((priceElement) => {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                priceElement.innerHTML = `
          <span class="price__sale">${this.formatMoney(variant.price)}</span>
          <span class="price__regular">${this.formatMoney(variant.compare_at_price)}</span>
        `;
            } else {
                priceElement.innerHTML = `<span class="price__regular">${this.formatMoney(variant.price)}</span>`;
            }
        });
    }

    updateAvailability(variant) {
        const availabilityElements = document.querySelectorAll('.availability-text');
        availabilityElements.forEach((element) => {
            const hasStock = variant.available && (!variant.inventory_management || variant.inventory_quantity > 0);

            if (hasStock) {
                element.textContent = 'En stock';
                element.className = 'availability-text availability-text--in-stock';
            } else {
                element.textContent = 'Rupture de stock';
                element.className = 'availability-text availability-text--out-of-stock';
            }
        });
    }

    formatMoney(cents) {
        const amount = cents / 100;
        return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
        }).format(amount);
    }

    updateStockQuantity(variant) {
        const stockStatus = document.querySelector('[data-stock-status]');
        if (!stockStatus) return;

        const stockText = stockStatus.querySelector('.stock-status__text');
        if (!stockText) return;

        if (variant && variant.inventory_management && variant.inventory_quantity !== undefined) {
            const quantity = variant.inventory_quantity;
            if (quantity > 0) {
                stockText.textContent = 'En stock';
                stockStatus.className = 'stock-status stock-status--in-stock';
            } else {
                stockText.textContent = 'En rupture de stock';
                stockStatus.className = 'stock-status stock-status--out-of-stock';
            }
            stockStatus.style.display = 'block';
        } else {
            stockStatus.style.display = 'none';
        }
    }

    updateVariantLabel(variant) {
        if (!window.productOptions || !variant.options) return;

        window.productOptions.forEach((optionName, index) => {
            const optionValue = variant.options[index];
            const labelSpan = document.querySelector(`[data-option="${optionName}"]`);

            if (labelSpan && optionValue) {
                labelSpan.textContent = optionValue;
            }
        });
    }

    updateQuantity(increase) {
        const quantityInput = document.querySelector('[data-quantity-input]');
        if (!quantityInput) return;

        const currentValue = parseInt(quantityInput.value) || 1;
        const newValue = increase ? currentValue + 1 : Math.max(1, currentValue - 1);

        quantityInput.value = newValue;
    }

    validateQuantity() {
        const quantityInput = document.querySelector('[data-quantity-input]');
        if (!quantityInput) return;

        const value = parseInt(quantityInput.value) || 1;
        quantityInput.value = Math.max(1, value);
    }

    setButtonLoading(button, loading) {
        const btnText = button.querySelector('.btn__text');
        const btnLoading = button.querySelector('.btn__loading');

        if (loading) {
            button.disabled = true;
            if (btnText) btnText.style.display = 'none';
            if (btnLoading) btnLoading.style.display = 'block';
        } else {
            button.disabled = false;
            if (btnText) btnText.style.display = 'block';
            if (btnLoading) btnLoading.style.display = 'none';
        }
    }

    async handleAddToCart() {
        const variantIdInput = this.form.querySelector('input[name="id"]');
        const quantityInput = this.form.querySelector('[data-quantity-input]');

        if (!variantIdInput || !variantIdInput.value) {
            this.showErrorMessage('Veuillez sélectionner une variante');
            return;
        }

        const variantId = parseInt(variantIdInput.value);
        const quantity = parseInt(quantityInput?.value || 1);

        this.setButtonLoading(this.addToCartBtn, true);

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [
                        {
                            id: variantId,
                            quantity: quantity
                        }
                    ]
                })
            });

            if (response.ok) {
                const data = await response.json();
                this.showSuccessMessage('Produit ajouté au panier');

                document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
            } else {
                const error = await response.json();
                this.showErrorMessage(error.message || 'Erreur lors de l\'ajout au panier');
            }
        } catch (error) {
            this.showErrorMessage('Erreur de connexion');
        } finally {
            this.setButtonLoading(this.addToCartBtn, false);
        }
    }

    showSuccessMessage(message) {
        if (window.toast) {
            window.toast.success(message);
        }
    }

    showErrorMessage(message) {
        if (window.toast) {
            window.toast.error(message);
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const tabsContainers = document.querySelectorAll("[data-tabs]");
    tabsContainers.forEach((container) => new ProductTabs(container));

    const accordions = document.querySelectorAll(".product-accordion");

    accordions.forEach((accordion) => {
        const content = accordion.querySelector(".product-accordion__content");

        accordion.addEventListener("toggle", () => {
            if (accordion.open) {
                content.style.maxHeight = content.scrollHeight + "px";
            } else {
                content.style.maxHeight = "0";
            }
        });
    });

    const descToggle = document.querySelector("[data-description-toggle]");
    const descText = document.querySelector("[data-description-text]");
    const toggleText = document.querySelector("[data-toggle-text]");

    if (descToggle && descText) {
        const isTextClamped = descText.scrollHeight > descText.clientHeight;

        if (!isTextClamped) {
            descToggle.style.display = "none";
        } else {
            descToggle.addEventListener("click", () => {
                const isExpanded = descText.classList.toggle("is-expanded");
                descToggle.classList.toggle("is-expanded", isExpanded);

                if (isExpanded) {
                    toggleText.textContent = "Voir moins";
                } else {
                    toggleText.textContent = "Voir plus";
                }
            });
        }
    }

    new ProductPageForm();
});